module.exports = "<div class=\"\" ng-show=\"loading\" style=\"margin-bottom: 20px;\">\n  Loading....\n</div>\n<div class=\"credit-card-preview\" ng-show=\"card && !loading\">\n  <p class=\"card-info\"> <span class=\"uppercase\">{{ card.cardType }}</span> ending in {{ card.last4 }}</p>\n  <p class=\"card-info\">Exp. {{ card.expirationMonth }}/{{ card.expirationYear }}</p>\n  <div class=\"remove-link\" ng-click=\"editCreditCard()\">Delete Card?</div>\n</div>\n<div class=\"credit-card-preview\" ng-show=\"!card && !loading\">\n  No Credit Cards to Show\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/creditCardPreview/template.html
// module id = 846
// module chunks = 1